import '../../../../assets/javascripts/funding/filters/funding_filters';
import '../../../../assets/javascripts/funding/funding';
import template from './report_header.template.html?raw';
import '../../../components/cloudinary_image/cloudinary_image.component';

const controller = function() {
  const that = this;

  /**
   * Checks if one of the types (passed as strings) matches the current active report type
   *
   * @param {Array.<string>} types - Array of values, passed as strings
   * @returns {boolean} true if the active report's value exists on the array of types,
   *                    false if not
   */
  that.reportOfType = types => devex.util.propertyIncludes(that.report.type, types);

  /**
   * Checks if the property exists with a valid value (not empty string,
   * not 0 number, not empty array, not empty object, not null, not undefined)
   * on the report
   *
   * @param {string} property - Property to be checked
   * @returns {boolean} true if the property exists on the report with a valid
   *                    value, false if not
   */
  that.reportContainsValid = property => devex.util.containsProp(that.report, property);

  /**
   * Checks if any of the properties exists with a valid value (not empty string,
   * not 0 number, not empty array, not empty object, not null, not undefined)
   * on the report
   *
   * @param {Array.<string>} properties - Properties to be checked, passed as strings
   * @returns {boolean} true if any of the properties exists on the report with a valid
   *                    value, false if not
   */
  that.reportContainsAnyValid = properties => devex.util.containsAnyProp(that.report, properties);

  /**
   * Returns title of the report
   *
   * @returns {string} - Title of the report
   */
  that.getTitle = () => that.report.editorialized_title || that.report.title;
};

const moduleDependencies = ['filters.funding', 'components.cloudinaryImage'];

angular
  .module('fundingSearchApp.directives.reportHeader', moduleDependencies)
  .run(['$templateCache', $templateCache => {
    $templateCache.put(template, template);
  }])
  .directive('reportHeader', () => ({
    restrict: 'E',
    templateUrl: template,
    scope: {
      report: '=',
      firstDonorLogoUrl: '&',
      hasDonorLogo: '&'
    },
    bindToController: true,
    controller,
    controllerAs: 'vm'
  }));
